module.exports = __webpack_public_path__ + "static/img/question.2a5f78f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/question.png
// module id = amoS
// module chunks = 6